class WishlistDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setWishlistButtons();
    }

    setWishlistButtons() {
        const buttons = document.querySelectorAll('.open-wishlist-drawer');

        buttons.forEach((el) => {
            if (el.hasAttribute('role') === false) {
                el.setAttribute('role', 'button');
                el.setAttribute('aria-haspopup', 'dialog');
                el.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.open(el)
                });

                el.addEventListener('keydown', (event) => {
                    if (event.code.toUpperCase() === 'SPACE') {
                        event.preventDefault();
                        this.open(el);
                    }
                });
            }
        });
    }

    bindData(data) {

        //console.log(data);

        if (data.length === 0) {
            this.classList.add('is-empty');
            this.querySelector('.drawer__inner-empty').classList.remove('hidden');
            this.querySelector('.drawer__inner-not-empty').classList.add('hidden');
        } else {

            let items = "";

            data.forEach((itemData) => {
                items += generateItem(itemData);
            });

            this.querySelector('.cart-items').innerHTML = items;

            this.classList.remove('is-empty');
            this.querySelector('.drawer__inner-empty').classList.add('hidden');
            this.querySelector('.drawer__inner-not-empty').classList.remove('hidden');
        }


        function getVariants(data) {
            let chunks1 = data.split('-');
            let data2 = chunks1[1] || '';
            let chunks2 = data2.split('/');
            let color = chunks2[0] || '';
            let size = chunks2[1] || '';

            return `<dl>
                <div class="product-option">
                    <dt>${Shopify.locale === 'it' ? 'Colore' : 'Color'}:</dt>
                    <dd>
                        ${color}
                    </dd>
                </div>
                <div class="product-option">
                    <dt>${Shopify.locale === 'it' ? 'Taglia' : 'Size'}:</dt>
                    <dd>
                        ${size}
                    </dd>
                </div>
            </dl>`;
        }

        function getCurrencySymbol(data) {
            if (data === 'EUR') return '€';
            if (data === 'USD') return '$';
            if (data === 'GBP') return '£';
            return '';
        }

        function generateItem(itemData) {

            if(itemData.DisplayCurrency === undefined) {
                itemData.DisplayCurrency = Shopify.currency.active;

                let price = itemData.Price || itemData.price;
                itemData.DisplayPrice = price;
            }

            return `
                <div class="cart-item">
                      
                  <div class="cart-item__details-totals">
                    <div class="cart-item__details" role="cell">
                      <a href="${itemData.ProductLink}" class="cart-item__name break">
                        ${itemData.ProductName.split('-')[0]}
                      </a>
                      ${getVariants(itemData.ProductName)}
                      <div class="product-option prodcut-option--price">
                        ${getCurrencySymbol(itemData.DisplayCurrency)}${itemData.DisplayPrice}
                      </div>
                    </div>
                  </div>

                  <div class="cart-item__media" role="cell">
                  
                  <a href="${itemData.ProductLink}" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>
                  <img
                          class="cart-item__image"
                          src="${itemData.ProductImage}"
                          alt=""
                          loading="lazy"
                  >
                  </div>

                  <div class="cart-item__quantity" role="cell">
                    <div class="wishlist-item__quantity-wrapper">
                      <wishlist-remove-button class="wishlist-remove-button" onClick="removeFromWishList(${itemData.ProductVariantId})">
                        <button type="button">
                          ${Shopify.locale === 'it' ? 'Rimuovi' : 'Remove'}
                        </button>
                      </wishlist-remove-button>
                    </div>
                  </div>

                </div>
            `;

            /* 
            let wizards = ['Hermione', 'Neville', 'Gandalf', 'Radagast'];
            let showHeading = true;
            return `
                <p>${itemData.ProductName}</p>
                ${showHeading ? `<h1>${itemData.ProductName}</h1>` : ''}
                <ul>
                    ${wizards.map(function (wizard) {
                return `<li>${wizard}</li>`;
            }).join('')}
                </ul>`;
           */
        }
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active')
        });

        this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('WishlistDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
        }, {once: true});

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('wishlist-drawer', WishlistDrawer);